export default __webpack_public_path__ + "static/media/arrow-up-right.7e00ff93.svg";